import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Subject } from 'rxjs';
import { map, scan } from 'rxjs/operators';

@Injectable()
export class UiLoaderService {
  private overlayTopRef: OverlayRef = this.cdkOverlayCreate();
  overlay$: Subject<boolean> = new Subject();
  isActive = false;

  constructor(private overlay: Overlay) {
    this.overlay$
      .asObservable()
      .pipe(
        map(val => val ? 1 : -1),
        scan((acc, one) => (acc + one) >= 0 ? acc + one : 0, 0)
      )
      .subscribe(
        (res) => {
          if (res === 1) {
            this.showOverlay();
          } else if (res === 0) {
            this.overlayTopRef.hasAttached() ? this.stopOverlay() : null;
          }
        }
      );
  }


  private cdkOverlayCreate() {
    return this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'sk-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    });
  }


  showOverlay() {
    if (!this.isActive) {
      this.overlayTopRef.attach(new ComponentPortal(MatSpinner));
      this.isActive = true;
    }
  }

  stopOverlay() {
    this.overlayTopRef.detach();
    this.isActive = false;
  }
}
